import { useMemo } from 'react';
import { calculateFooter } from './useFooterCalculation';

export const useOogRows = (raw, columns) =>
  useMemo(() => {
    const source = (raw && raw.data) || raw;
    if (!source || typeof source !== 'object') return [];

    return Object.entries(source).map(([groupTitle, rows]) => {
      const items = rows.map((item) => {
        if (item.length === 5) {
          const [date, shift, oogType, hours] = item;
          return { date, shift, oogType, hours };
        }

        const [date, employee, _, shift, oogType, hours] = item;
        return { date, shift, oogType, hours, employee };
      });

      const footer = calculateFooter(items, columns);

      return {
        name: groupTitle,
        items,
        footer,
      };
    });
  }, [raw, columns]);
